module.exports = __webpack_public_path__ + "img/fabienne.db85a344.jpg";